import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Loader from "./Loader";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement, // ✅ Import BarElement
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Bar } from "react-chartjs-2"; // ✅ Import Bar chart
import dayjs from "dayjs";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement, // ✅ Register BarElement
  Title,
  Tooltip,
  Legend
);

const baseUrl = process.env.REACT_APP_API_BASE_URL;

export default function UserChartPage() {
  const [filterType, setFilterType] = useState("week");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchChartData = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        filterType,
        startDate: startDate ? new Date(startDate).toISOString() : null,
        endDate: endDate ? new Date(endDate).toISOString() : null,
      };
      const token = localStorage.getItem("token");
      const { data } = await axios.post(`${baseUrl}/auth/dashboard/user-chart`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (data?.status && data.data) {
        const labels = data.data.map(item =>
          dayjs(item.date).format("DD MMM")
        );
        const values = data.data.map(item => item.totalUser);

        setChartData({
          labels,
          datasets: [
            {
              label: "Users",
              data: values,
              backgroundColor: "#28a265c0",
              borderColor: "#28a265",
              borderWidth: 1
            }
          ]
        });
      }
    } catch (error) {
      console.error("Error fetching chart data:", error);
    }
    setLoading(false);
  }, [filterType, startDate, endDate]);

  useEffect(() => {
    fetchChartData();
  }, [fetchChartData]);

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h1 className="text-2xl font-bold mb-6 text-gray-800">User Growth Chart</h1>

      {/* Filters */}
      <div className="flex flex-wrap gap-4 mb-6 bg-white border border-gray-200 p-4 rounded-lg shadow-sm">
        <select
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
          className="bg-white border border-gray-300 text-gray-800 rounded px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="today">Today</option>
          <option value="week">This Week</option>
          <option value="month">This Month</option>
          <option value="year">This Year</option>
          <option value="custom">Custom</option>
        </select>

        {filterType === "custom" && (
          <>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="bg-white border border-gray-300 text-gray-800 rounded px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="bg-white border border-gray-300 text-gray-800 rounded px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </>
        )}

        <button
          onClick={fetchChartData}
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors"
        >
          Refresh
        </button>
      </div>

      {/* Chart */}
      <div className="bg-white border border-gray-200 p-6 rounded-lg shadow-sm">
        {loading ? (
          <Loader text="Loading chart..." />
        ) : chartData ? (
          <Bar
            data={chartData}
            options={{
              responsive: true,
              plugins: {
                legend: { position: "top" },
                title: { display: true, text: "User Registrations" },
              },
              scales: {
                x: {
                  grid: { color: "rgba(0, 0, 0, 0.05)" },
                  ticks: { color: "#374151" }
                },
                y: {
                  grid: { color: "rgba(0, 0, 0, 0.05)" },
                  ticks: { color: "#374151" }
                }
              },
            }}
          />
        ) : (
          <p>No data available</p>
        )}
      </div>

    </div>
  );
}
